import * as types from "../../actions/actionsTypes/__configActionTypes";

export const initialStateConfiguration = {
    fileConf: null,
    versionBackEnd: null,
    versionFrontEnd: null
};

export const configurationReducer = (state = initialStateConfiguration, action) => {
    switch (action.type) {
        case types.GET_CONFIG_SUCCESS :
            return {
                ...state,
                fileConf: action.fileConf,
                versionFrontEnd: action.fileConf.version
            };

        case types.GET_VERSION_BACK_END_SUCCESS :
            return {
                ...state,
                versionBackEnd: action.versionBackEnd
            };

        default :
            return state
    }
};
